import React, { useEffect, useState } from "react";
import "./ViewStore.css";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { eye } from "react-icons-kit/feather/eye";
import { arrowUpRight } from "react-icons-kit/feather/arrowUpRight";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  GetSubCategoryImage,
  GetstoreById,
  api_url,
} from "../apiconfig/authService";

function ViewStore() {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const [subcategoryData, setSubcategoryData] = useState([]);
  const { subcategoryid } = useParams();
  const [mediaData, setMediaData] = useState([]);
  const { storeid } = useParams();

  console.log(mediaData);

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };
    const readableFormat = date.toLocaleString(undefined, options);
    return readableFormat.substring(0, readableFormat.length - 9);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await GetstoreById(
          storeid,
          localStorage.getItem("accessToken")
        );
        setMediaData(response.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div className="dashboard-content">
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Store Details</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/stores" className="btn btn-primary addSeller">
              <Icon className="eye" icon={eye} size={18} /> View All
            </NavLink>
            <NavLink
              to={`/editStore/${storeid}`}
              className="btn btn-primary addSeller"
            >
              <Icon className="arrowUpRight" icon={arrowUpRight} size={18} />{" "}
              Edit
            </NavLink>
          </div>
        </div>
        <div className="detailsBox">
          <div className="row">
            <div className="col-lg-12">
              <div className="table-responsive">
                <table className="table table-bordered table-hover w-100">
                  <tbody>
                    <tr>
                      <th>Title</th>
                      <td>{mediaData?._doc?.storename}</td>
                    </tr>
                    <tr>
                      <th>Image</th>
                      <td>
                        <img
                          width="100px"
                          height="100px"
                          src={`${api_url}/product/category/getSubcategoryImage/${mediaData?._doc?.image}`}
                        />
                      </td>
                    </tr>
                    {/* <tr>
                                            <th>Status</th>
                                            <td>{mediaData?.statusInfo?.status}</td>
                                        </tr> */}
                    <tr>
                      <th>Created Date</th>
                      <td>{formatUTCDate(mediaData?._doc?.createdDate)}</td>
                    </tr>
                    <tr>
                      <th>Modified Date</th>
                      <td>{formatUTCDate(mediaData?._doc?.modifyDate)}</td>
                    </tr>
                    <tr>
                      <th>Created By</th>
                      <td>{mediaData?._doc?.createdBy}</td>
                    </tr>
                    <tr>
                      <th>Modified By</th>
                      <td>{mediaData?._doc?.modifyBy}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewStore;
